import React, { useState, useRef } from 'react';
import { GREEN, GREEN_LIGHT } from '../constants';
import { mono } from '../styles';

export default function FileUpload({ ob, onUpdate, clientName }) {
  const [files, setFiles] = useState(ob.files || []);
  const [drag, setDrag]   = useState(false);
  const ref = useRef();

  function handleFiles(newFiles) {
    const added = Array.from(newFiles).map(f => ({
      id: String(Date.now() + Math.random()),
      name: f.name, size: f.size, type: f.type,
      uploadedAt: new Date().toISOString(),
    }));
    const updated = [...files, ...added];
    setFiles(updated);
    const newDone = ob.completedSteps.includes('files')
      ? ob.completedSteps
      : [...ob.completedSteps, 'files'];
    onUpdate({ ...ob, files: updated, completedSteps: newDone });
  }

  function remove(idx) {
    const updated = files.filter((_, i) => i !== idx);
    setFiles(updated);
    onUpdate({ ...ob, files: updated });
  }

  function fmt(b) {
    if (b < 1024) return b + 'B';
    if (b < 1048576) return (b / 1024).toFixed(1) + 'KB';
    return (b / 1048576).toFixed(1) + 'MB';
  }

  return (
    <div>
      <div style={{ fontWeight: 800, fontSize: 17, marginBottom: 4 }}>Upload Brand Files</div>
      <div style={{ ...mono, marginBottom: 12 }}>{files.length} file{files.length !== 1 ? 's' : ''} uploaded</div>

      <div style={{ background: '#f0f7ff', border: '1.5px solid #bfdbfe', borderRadius: 10, padding: '9px 13px', marginBottom: 12, fontSize: 12, color: '#1e40af' }}>
        Files saved locally. Google Drive integration can be added via the API.
        Folder structure: Clients / {clientName} / Brand Assets - Creative - Documents
      </div>

      <div
        onDragOver={e => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={e => { e.preventDefault(); setDrag(false); handleFiles(e.dataTransfer.files); }}
        onClick={() => ref.current.click()}
        style={{
          border: `2px dashed ${drag ? GREEN : '#ddd'}`,
          borderRadius: 12, padding: '24px 16px', textAlign: 'center',
          cursor: 'pointer', background: drag ? GREEN_LIGHT : '#fafafa',
          transition: 'all .2s', marginBottom: 12,
        }}
      >
        <input ref={ref} type="file" multiple style={{ display: 'none' }} onChange={e => handleFiles(e.target.files)} />
        <div style={{ fontWeight: 700, marginBottom: 3, fontSize: 15 }}>Drop files here or click to browse</div>
        <div style={mono}>Logos, images, docs, sheets — any file type</div>
      </div>

      {files.map((f, i) => (
        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8f8f6', borderRadius: 8, padding: '6px 12px', marginBottom: 4 }}>
          <span style={{ fontSize: 13, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.name}</span>
          <span style={{ ...mono, marginLeft: 8, flexShrink: 0 }}>{fmt(f.size)}</span>
          <button onClick={() => remove(i)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, marginLeft: 8, opacity: 0.4 }}>x</button>
        </div>
      ))}
    </div>
  );
}
